$(document).ready(function() {
    $(document).on('change', '.main-gift-wrap',async function (event) {
        event.preventDefault();
        let allData = $(this).data();
        let mainprodID = allData.mainprodId;
        let mainprodKey = allData.mainprodKey;
        let mainprodLine = allData.mainprodLine;
        let giftwrapprodID = allData.id;
        let qtyVal = allData.mainprodQty;
        let mainprodType = allData.mainprodType; 
        let mainprodTitle = allData.mainprodTitle; 
        let giftvariant = allData.giftwrap_id; 
       
        if ($(this).hasClass('checked')) {
          $('.main-gift-wrap').attr('disabled', true); 
          $('.assembly_charges').attr('disabled', true);
            showGiftcheckboxLoader($(this));
            $(this).removeClass('checked');
            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: JSON.stringify({
                  id: findAssemblyItemKey(giftwrapprodID,mainprodID),
                  quantity: 0
                }),
                contentType: 'application/json',
                dataType: 'json',
                success: async function (response) {
                  const productKey = findProductItemKey(giftwrapprodID,mainprodID);

                  let props = await getItemProperties(productKey);
                  if ("_checked_giftwrap" in props) {
                    delete props["_checked_giftwrap"];
                  }
                  if ("_datagiftwrapID" in props) {
                    delete props["_datagiftwrapID"];
                  }
                  if ("_datagiftwrapvariant" in props) {
                    delete props["_datagiftwrapvariant"];
                  }
                  props['GiftWrap'] ="No"
                  $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    data: JSON.stringify({
                        id: productKey,
                        quantity:qtyVal,
                        properties: props // Clear properties
                    }),
                    contentType: 'application/json',
                    dataType: 'json',
                    success: function(updatedCart) {
                          hideGiftcheckboxLoader($(this));
                          $('.main-gift-wrap').attr('disabled', false); 
                          $('.assembly_charges').attr('disabled', false);
                          window.location.href = "/cart";
                    },
                    error: function(xhr, status, error) {
                        hideGiftcheckboxLoader($(this));
                          $('.main-gift-wrap').attr('disabled', false); 
                          $('.assembly_charges').attr('disabled', false);
                            console.error('Error updating parent product:', xhr.responseText);
                    }
                  });
                //  updateCartView(response);
                  return;
                },
                error: function (xhr, status, error) {
                    hideGiftcheckboxLoader($(this));
                          $('.main-gift-wrap').attr('disabled', false); 
                          $('.assembly_charges').attr('disabled', false);
                  console.error('Error removing assembly product from cart:', error);
                }
              });
        }else{
            hideGiftWrapLoader();
            $(this).addClass('open-giftwrap-model')
            $(this).addClass('checked');
            $(this).prop('checked', true);
            $("#confirmation-gift-wrap").fadeIn();
        
            const index = $(this).attr('index-id');
            $('#confirmation-gift-wrap').attr('index-id', index);

            // message field characters counting
            $('#message').on('input', function () {
                var currentLength = $(this).val().length;
                $('#char-count').text(currentLength + '/200');
            });

            // When the user clicks the "Add Gift Wrap" button
            $(document).on('click', '#add-giftwrap', function(event) {
                event.preventDefault();
                $(this).prop('disabled', true);
                showGiftWrapLoader();
                var recipientName = $('#recipient-name').val();
                var message = $('#message').val();
                var senderName = $('#sender-name').val();
                document.querySelectorAll(".error-message").forEach((el) => el.remove());
    
                let hasErrors = false;  
    
                if (!recipientName) {
                    showError("recipient-name", "Recipient is required.");
                    hasErrors = true;
                  }
                  if (!senderName) {
                    showError("sender-name", "Sender is required.");
                    hasErrors = true;
                  }
                  if (hasErrors) {
                    hideGiftWrapLoader();
                    $(this).prop('disabled', false);
                    return; 
                  }
                // Get the necessary data from allData
                // let mainprodID = allData.mainprodId;
                // let mainprodKey = allData.mainprodKey;
                // let giftwrapprodID = allData.id;
                // let qtyVal = allData.mainprodQty;
                // let mainprodType = allData.mainprodType; 
                // let mainprodTitle = allData.mainprodTitle; 
                let returnItemId = '';
                // let giftvariant = allData.giftwrap_id; 
    
                // Add gift-wrap product to cart
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: JSON.stringify({
                        items: [
                            {
                                id: giftwrapprodID,
                                quantity: qtyVal,
                                properties: {
                                    "_datamaingiftprodid": mainprodID,
                                    "_datamaingiftprodtype": mainprodType,
                                    "_datamaingiftprodtitle": mainprodTitle,
                                    "__gift_recipientName": recipientName,
                                    "__gift_giftwrapMessage": message,
                                    "__gift_senderName":senderName
                                }
                            }
                        ]
                    }),
                    contentType: 'application/json',
                    dataType: 'json',
                    success: async function(response) {
                        let returnItem = response?.items.length? response.items[0]: null
                        if(returnItem){
                            returnItemId = returnItem.id;
                        }
                        const updatedmainprodKey = await getCart(mainprodID);
                        let propsexisting = await getItemProperties(updatedmainprodKey);
                        if ("GiftWrap" in propsexisting) {
                            delete propsexisting["GiftWrap"];
                          }
                        let propsNew = { 
                            "_checked_giftwrap": true,
                            "_datagiftwrapID": returnItemId,
                            "_datagiftwrapvariant": giftvariant
                           };
                        let finalProps = {...propsexisting,...propsNew}
    
                        // Update the main product in the cart
                        $.ajax({
                            type: 'POST',
                            url: '/cart/change.js',
                            data: JSON.stringify({
                                // id: updatedmainprodKey,
                                line: mainprodLine+1,
                                quantity: qtyVal,
                                properties: finalProps
                            }),
                            contentType: 'application/json',
                            dataType: 'json',
                            success: function(response) {
                                hideGiftWrapLoader();
                                $(this).removeClass('open-giftwrap-model')
                                $(this).prop('disabled', false);
                                window.location.href = "/cart";
                            },
                            error: function(xhr, status, error) {
                                hideGiftWrapLoader();
                                $(this).prop('disabled', false);
                                console.error('Error updating cart:', error);
                            }
                        });
                    },
                    error: function(xhr, status, error) {
                        hideGiftWrapLoader();
                        $(this).prop('disabled', false);
                        console.error('Error adding assembly product to cart:', error);
                    }
                });
            });
        }
        

    });

    // Close the gift wrap confirmation modal
    $("#closeBtn").click(function() {
      var $targetGiftWrap = $('.main-gift-wrap.open-giftwrap-model');
      
      // if ($targetGiftWrap.length) {
        console.log($targetGiftWrap)
        $targetGiftWrap.removeClass('open-giftwrap-model'); 
        $targetGiftWrap.removeClass('checked');
        $targetGiftWrap.prop('checked', false);
      // }
    
      $("#confirmation-gift-wrap").fadeOut(); 
    });
    
});

function findAssemblyItemKey(giftwrapID,productId) {
    let lineItemKey = null;
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      async: false, 
      dataType: 'json',
      success: function (cart) {
        cart.items.forEach(item => {
          if (item.variant_id == giftwrapID && item.properties && item.properties?._datamaingiftprodid == productId) {
            lineItemKey = item.key;
          }
        });
      },
      error: function () {
        console.error('Error retrieving cart.');
      }
    });
    return lineItemKey;
  }
  function findProductItemKey(giftwrapID,productId) {
    let lineItemKey = null;
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      async: false, // Synchronous request to get cart contents
      dataType: 'json',
      success: function (cart) {
        cart.items.forEach(item => {
          if (item.variant_id == productId && item.properties && item.properties?._datagiftwrapID == giftwrapID) {
        //   if (item.variant_id == productId) {
            lineItemKey = item.key;
          }
        });
      },
      error: function () {
        console.error('Error retrieving cart.');
      }
    });
    return lineItemKey;
  }

  async function getItemProperties(itemKey){
    try {
      const cartResponse = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      if (!cartResponse.ok) {
        console.error('Failed to fetch current cart data:', cartResponse.statusText);
        return null;
      }
      const cartData = await cartResponse.json();
        const lineItem = cartData.items.find(item => item.key == itemKey);
          return  lineItem.properties || {};
    } catch (error) {
      console.error('Error fetching cart items:', error);
      return null;
    }
}
function showError(fieldId, message) {
    const field = document.getElementById(fieldId);
    if (field) {
      const errorElement = document.createElement("span");
      errorElement.className = "error-message text-red-500 text-xs mt-1 block";
      errorElement.textContent = message;
      field.parentElement.appendChild(errorElement);
    }
  }
  function showGiftWrapLoader() {
    const loader = document.querySelector('#giftwrapLoader');
    loader.style.display = 'block'; 
  }
  
  function hideGiftWrapLoader() {
    const loader = document.querySelector('#giftwrapLoader');
    loader.style.display = 'none';
  }
  function showGiftcheckboxLoader(element) {
    const loader = element.closest('.giftwrap_value').find('#giftcheckboxLoader');
    loader.css('display', 'block'); 
  }
  
  function hideGiftcheckboxLoader(element) {
    const loader = element.closest('.giftwrap_value').find('#giftcheckboxLoader');
   loader.css('display', 'none');
  }
